import Vue from 'vue'
import VueClickOutside from 'vue-click-outside'
Vue.directive('click-outside', VueClickOutside)
